type StorageBreakdown = {
  document: number;
  video: number;
  blockchain: number;
};

const clamp = (value: number, maximum: number) => Math.min(Math.max(value, 0), maximum);

export const calculateStorageBreakdown = (
  used: number,
  meetingSize: number,
  blockchainSize: number
): StorageBreakdown => {
  const safeUsed = Math.max(used, 0);
  const video = clamp(meetingSize, safeUsed);
  const blockchain = clamp(blockchainSize, safeUsed - video);

  return {
    document: safeUsed - video - blockchain,
    video,
    blockchain,
  };
};

export const toVisiblePercentage = (value: number, total: number) => {
  if (value <= 0 || total <= 0) return 0;

  return Math.max(1, (value / total) * 100);
};
